import './AutoCompleteSelect.scss';

import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import PropTypes from 'prop-types';
import ExpandMoreIcon from '@mui/icons-material/ExpandMoreSharp';

export default function AutoCompleteSelect (props) {
  const {
    onChangeFn,
    options,
    id,
    initialValues,
    placeholder,
    disableBlur
  } = props;
  const handleChange = (e, value) => {
    onChangeFn(value, id);
  };

  const getOptionLabel = (option) => {
    if (typeof option === 'string') return option;
    if (typeof option === 'number') return String(option);
    return option?.label || option?.value || '';
  };

  return (
    <Autocomplete
      disablePortal
      id={`auto-complete-select-${id}`}
      value={initialValues}
      popupIcon={<ExpandMoreIcon />}
      options={options}
      getOptionLabel={getOptionLabel}
      onBlur={disableBlur ? undefined : () => onChangeFn(null, null)}
      blurOnSelect={true}
      openOnFocus={true}
      renderOption={(props, option) => {
        const optionLabel = getOptionLabel(option);
        return (
          <li {...props} className="autocomplete-option">
            {optionLabel}
          </li>
        );
      }}
      renderInput={(params) =>
        <TextField
          InputLabelProps={{ shrink: false }}
          size="small"
          {...params}
          placeholder={placeholder}
        />
      }
      onChange={handleChange}
    />
  );
}

AutoCompleteSelect.propTypes = {
  options: PropTypes.array,
  onChangeFn: PropTypes.func,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  initialValues: PropTypes.object,
  filterOptions: PropTypes.func,
  disableBlur: PropTypes.bool
};

AutoCompleteSelect.defaultProps = {
  disableBlur: false,
};
